import { useMutation, useQueryClient } from "react-query";
import { AxiosError } from "axios";

import { useUser } from "@/providers/context";
import { Playlist, PlaylistResponse, reorderPlaylists } from "@/api";

export const useReorderPlaylists = () => {
  const queryClient = useQueryClient();
  const { uid } = useUser();

  return useMutation<
    PlaylistResponse | undefined,
    AxiosError<{ error: string }>,
    { playlists: Playlist[] }
  >(
    async ({ playlists }) => {
      if (uid) {
        return await reorderPlaylists({ user_id: uid, playlists });
      }
    },
    {
      onSuccess: (data) => {
        if (data) {
          queryClient.setQueryData(["playlists", uid], data);
        }
      },
    },
  );
};
